import * as z from "zod";
import type { TFunction } from "i18next";

export const createLogsExportSchema = (t: TFunction) =>
  z
    .object({
      columns: z
        .array(z.string())
        .min(1, t("management.log.validation.columnsRequired")),
      startDate: z
        .string()
        .min(1, t("management.log.validation.startDateRequired")),
      endDate: z
        .string()
        .min(1, t("management.log.validation.endDateRequired")),
    })
    .refine(
      (data) =>
        !data.startDate || !data.endDate || data.startDate <= data.endDate,
      {
        message: t("management.log.validation.dateRangeInvalid"),
        path: ["endDate"],
      },
    );
